/**
 * 优惠券列表
 */
import { COUPONLIST } from '../types';

export default {
    name: `${COUPONLIST}`,
    path: '/couponList',
    component: () => import(/* webpackChunkName: 'couponList' */ '@/views/couponList/'),
    redirect: { name: `${COUPONLIST}Index` },
    meta: {
        title: '优惠券列表',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${COUPONLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'couponList' */ '@/views/couponList/home/Home.vue'),
        },
        // 优惠券详情
        {
            name: `${COUPONLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'couponListDetail' */ '@/views/couponList/detail/Detail.vue'),
        },
        // 优惠券创建
        {
            name: `${COUPONLIST}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'couponListCreate' */ '@/views/couponList/create/Create.vue'),
        },
        // 优惠券编辑
        {
            name: `${COUPONLIST}Edit`,
            path: 'create/:id',
            component: () => import(/* webpackChunkName: 'couponListEdit' */ '@/views/couponList/create/Edit.vue'),
        },
        // 发券\券包
        {
            name: `${COUPONLIST}Send`,
            path: 'send/:id',
            component: () => import(/* webpackChunkName: 'couponListSend' */ '@/views/couponList/send/Send.vue'),
        },
    ],
};
